import { createFileRoute } from "@tanstack/react-router";
import TermsConditions from "@/pages/TermsConditions";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/terms-conditions")({
  head: () =>
    buildHead({
      title: "Terms & Conditions | Precision Pavers & Pool Design",
      description:
        "Terms and conditions for Precision Pavers & Pool Design. Read our policies regarding service estimates, project agreements, and website usage for Broward County customers.",
      path: "/terms-conditions",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Terms & Conditions",
            item: "https://precisionpaverspools.com/terms-conditions",
          },
        ],
      },
    }),
  component: TermsConditions,
});
